import { useLazyIndexedDBRestQuery } from '@repo/services';
import { type TenantInfoType } from '@repo/utils';
import { CaseUtil } from '@vectord/utils';
import { useEffect } from 'react';

export const TENANT_INFO_ENDPOINT = '/v1/tenants/info';
export const TENANT_INFO_CACHE_KEY = 'tenant-info';

export const useFetchTenantInfo = ({ skip = false }: { skip?: boolean } = {}) => {
  const [fetchTenantInfo, {
    data: tenantInfoData,
    isLoading,
    error,
  }] = useLazyIndexedDBRestQuery<void, TenantInfoType>({
    endpoint: TENANT_INFO_ENDPOINT,
    method: 'GET',
    cacheKey: TENANT_INFO_CACHE_KEY,
    transform: (data: any) => CaseUtil.toCase('camelCase', data),
  });

  useEffect(() => {
    if (error) { return; }

    if (!skip && !isLoading && !tenantInfoData) {
      fetchTenantInfo({ endpoint: TENANT_INFO_ENDPOINT });
    }
  }, [fetchTenantInfo, skip, tenantInfoData, isLoading, error]);

  return {
    fetchTenantInfo,
    tenantInfoData,
    isLoading,
    error,
  };
};
